import { render, staticRenderFns } from "./biller-product-rule.vue?vue&type=template&id=cbf8e692&"
import script from "./biller-product-rule.vue?vue&type=script&lang=js&"
export * from "./biller-product-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports